module.exports = __webpack_public_path__ + "static/media/Python.5a6a6439.png";